/* eslint-disable */
export function regHeader(user) {
  // return registration body
  let body = {
    "username": user.email,
    "password": user.password,
    "name": user.name,
    "phone": user.phone,
    "address":
    {
      "number": user.number,
      "numberExtra": user.numberExtra,
      "postalCode": user.postalCode,
      "country": user.country
    }
  };

  if(user.code) {
    body = {
      "user": {
      ...body
      },
      "code": user.code
    };
  }

  if (body) {
    return JSON.stringify(body);
  }
  return {};
}
/* eslint-enable */
